import { ancienneteBordereau } from './ancienneteBordereau';

/**
 * Ce qu'on peut faire d'un bordereau, selon son statut.
 *
 * POURQUOI CETTE FONCTION EXISTE. Le serveur sait faire d'un BROUILLON quatre choses
 * que l'ecran n'offrait pas : modifier son en-tete (PUT /{id}), ajouter un courrier
 * (POST /{id}/courriers/{courrierId}), en retirer un (DELETE du meme chemin), et le
 * supprimer (DELETE /{id}). Il refuse en revanche toute modification des autres
 * statuts : « Un bordereau IMPRIME n'est plus modifiable ».
 *
 * CE QUI EST EN JEU. Offrir une action a un statut qui la refuse fait ressaisir un
 * formulaire entier pour un refus a l'envoi. L'omettre a un statut qui l'accepte rend
 * la fonctionnalite introuvable - c'est ce qui se passait. Dans les deux cas rien ne
 * leve, et c'est la meme classe de defaut que la condition inversee de la colonne
 * « Ancienneté » : un ecran parfaitement plausible et faux.
 *
 * L'INCONNU NE PERMET RIEN. Un statut ajoute cote serveur n'ouvre par defaut aucune
 * ecriture : sur de l'inconnu, le defaut sur est de ne rien permettre.
 */
export function actionsPossibles(bordereau, maintenant = new Date()) {
  const statut = bordereau && bordereau.statut;
  const brouillon = statut === 'BROUILLON';

  return {
    /* On reimprime un bordereau perdu quel que soit son avancement - mais encore
       faut-il qu'il existe. */
    imprimer: !!statut,

    // Les trois que l'ecran n'offrait pas.
    modifier: brouillon,
    gererCourriers: brouillon,
    supprimer: brouillon,

    remis: statut === 'IMPRIME',
    decharge: statut === 'REMIS_TRANSPORTEUR',

    /* LE MEME RETARD QUE LA COLONNE « Ancienneté », et non un second calcul : les deux
       pouvaient se contredire - un bordereau signale en retard sans bouton pour le
       relancer, ou l'inverse. */
    relancer: statut === 'REMIS_TRANSPORTEUR'
      && ancienneteBordereau(bordereau, maintenant).enRetard,
  };
}
